/**
 * Organization Hierarchy GraphQL queries
 */

// Get complete organization hierarchy for ROOT users
export const GET_ORGANIZATION_HIERARCHY_QUERY = `
  query GetOrganizationHierarchy {
    companies(order_by: { name: asc }) {
      id
      name
      groups(order_by: { name: asc }) {
        id
        name
        description
        group_manager_id
        user {
          id
          first_name
          last_name
          email
          role
        }
        teams(order_by: { name: asc }) {
          id
          name
          description
          team_manager_id
          user {
            id
            first_name
            last_name
            email
            role
          }
          users(order_by: { first_name: asc }) {
            id
            first_name
            last_name
            email
            role
            title {
              id
              title_name
            }
          }
        }
      }
    }
  }
`;

// Get organization hierarchy by company (for non-ROOT users)
export const GET_ORGANIZATION_HIERARCHY_BY_COMPANY_QUERY = `
  query GetOrganizationHierarchyByCompany($companyId: Int!) {
    companies(where: { id: { _eq: $companyId } }) {
      id
      name
      groups(order_by: { name: asc }) {
        id
        name
        description
        group_manager_id
        user {
          id
          first_name
          last_name
          email
          role
        }
        teams(order_by: { name: asc }) {
          id
          name
          description
          team_manager_id
          user {
            id
            first_name
            last_name
            email
            role
          }
          users(order_by: { first_name: asc }) {
            id
            first_name
            last_name
            email
            role
            title {
              id
              title_name
            }
          }
        }
      }
    }
  }
`;

// Get unassigned users (users without teams)
export const GET_UNASSIGNED_USERS_QUERY = `
  query GetUnassignedUsers {
    users(where: { team_id: { _is_null: true } }, order_by: { first_name: asc }) {
      id
      first_name
      last_name
      email
      role
      company {
        id
        name
      }
      title {
        id
        title_name
      }
    }
  }
`;

// Get unassigned users by company
export const GET_UNASSIGNED_USERS_BY_COMPANY_QUERY = `
  query GetUnassignedUsersByCompany($companyId: Int!) {
    users(
      where: { 
        team_id: { _is_null: true },
        company_id: { _eq: $companyId }
      }, 
      order_by: { first_name: asc }
    ) {
      id
      first_name
      last_name
      email
      role
      company {
        id
        name
      }
      title {
        id
        title_name
      }
    }
  }
`; 